'use client';

import { c as _c } from "react/compiler-runtime";
import { Search, Handshake, Rocket } from 'lucide-react';
import Link from 'next/link';
const steps = [{
  number: '01',
  icon: Search,
  title: 'Choose your initiative',
  description: 'Consumer promotions, sampling, buyer expos, pitch events — pick what fits.',
  color: 'bg-orange-100 text-orange-600'
}, {
  number: '02',
  icon: Handshake,
  title: 'Set up & target',
  description: 'Define your audience, location, and format. Connect with venues, retailers, or go direct.',
  color: 'bg-blue-100 text-blue-600'
}, {
  number: '03',
  icon: Rocket,
  title: 'Launch & iterate',
  description: 'Go live fast, learn what works, and try the next thing.',
  color: 'bg-green-100 text-green-600'
}];
export function HowItWorksSection() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="text-center mb-16"><h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">From idea to live initiative in 3 steps</h2><p className="text-lg text-gray-500 max-w-xl mx-auto">Whether it's a consumer promotion, a buyer pitch event, or an in-store activation.</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 max-w-4xl mx-auto">{steps.map(_temp)}</div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section className="py-20 lg:py-28 bg-white"><div className="container mx-auto px-4 sm:px-6 lg:px-8">{t0}{t1}<div className="text-center mt-12"><Link href="/opportunities" className="inline-flex items-center gap-2 text-primary-600 font-semibold hover:underline cursor-pointer text-2xl">Browse opportunities →</Link></div></div></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp(step) {
  return <div key={step.number} className="text-center group"><div className={`w-16 h-16 rounded-2xl ${step.color} flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300`}><step.icon className="h-7 w-7" /></div><div className="text-xs font-bold text-gray-300 uppercase tracking-widest mb-2">Step {step.number}</div><h3 className="text-xl font-bold text-gray-900 mb-2">{step.title}</h3><p className="text-gray-500 leading-relaxed">{step.description}</p></div>;
}